



































































































import {
  FETCH_USER_PROFILES_FUNCTIONALITIES,
  GET_LOGGED_USER,
  GET_LOGGED_USER_FUNCTIONALITIES,
  CREATE_LOGGED_USER,
} from '@/modules/home/store';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import AuthService from '@/services/AuthService';
import {IAuthUser} from '@/modules/home/models';
import {IFunctionality} from '@/modules/functionality/models/Functionality';
import {GET_COUNTRY_SELECTED, UPDATE_COUNTRY_SELECTED} from '@/store/root';
import {CountryEnum} from '@/models/Enums';

const auth = new AuthService();

@Component
export default class extends Vue {
  public path = '/';
  public clipped = false;
  public drawer = true;
  public fixed = true;
  public miniVariant = false;
  public right = true;
  public rightDrawer = false;
  public title = 'Painel de controle';
  public countries = [
    {text: 'Brasil', value: CountryEnum.Brasil},
    {text: 'Argentina', value: CountryEnum.Argentina},
    {text: 'Equador', value: CountryEnum.Equador},
    {text: 'Peru', value: CountryEnum.Peru},
    {text: 'Colômbia', value: CountryEnum.Colombia},
    {text: 'Uruguai', value: CountryEnum.Uruguai},
    {text: 'Chile', value: CountryEnum.Chile},
    {text: 'República Dominicana', value: CountryEnum.RepublicaDominicana},
    {text: 'Guatemala', value: CountryEnum.Guatemala},
    {text: 'Costa Rica', value: CountryEnum.CostaRica},
    {text: 'El Salvador', value: CountryEnum.ElSalvador},
    {text: 'Panamá', value: CountryEnum.Panama},
    {text: 'Paraguai', value: CountryEnum.Paraguai},
  ];
  public items = [
    // { icon: 'device_hub', title: 'Acesso Dealer', to: '/controlpanel/dealer-access' },
    {icon: 'home', title: 'Home', to: '/home'},
    {
      icon: 'supervisor_account',
      title: 'Tipos de Usuário',
      to: '/user-type',
    },
    {icon: 'computer', title: 'Sistemas', to: '/system'},
    {
      icon: 'assignment',
      title: 'Funcionalidades',
      to: '/functionality',
    },
    {icon: 'perm_identity', title: 'Perfis', to: '/profile'},
    {icon: 'account_circle', title: 'Usuários', to: '/user'},
    {icon: 'directions_car', title: 'Classificação de Modelo', to: '/neovehicle/model'},
    {icon: 'list', title: 'Classificação de Segmento', to: '/neovehicle/family'},
    {icon: 'view_day', title: 'Classificados do dia', to: '/neovehicle/lastclassification'},
    {icon: 'graphic_eq', title: 'PVC', to: '/neopvc/project'},
  ];
  public country = CountryEnum;
  public countrySelectedInternal: CountryEnum;
  public isShowCountryControl = false;

  @Getter(GET_LOGGED_USER)
  public authUser: IAuthUser;

  @Getter(GET_LOGGED_USER_FUNCTIONALITIES)
  public userFunctionalities: IFunctionality[];

  @Getter(GET_COUNTRY_SELECTED)
  public countrySelected: CountryEnum;

  @Action(FETCH_USER_PROFILES_FUNCTIONALITIES)
  public getUserProfileFunctionalities: any;

  @Action(CREATE_LOGGED_USER)
  public setLoggedUser: any;

  @Action(UPDATE_COUNTRY_SELECTED)
  private setCountrySelected: (selected: CountryEnum) => void;

  public changeCountry(selected: CountryEnum) {
    this.setCountrySelected(selected);
  }

  @Watch('$route.path')
  public buildCountryControl() {
    this.isShowCountryControl = this.$route.path.includes('neovehicle');
  }

  public mounted() {
    this.buildCountryControl();
    this.countrySelectedInternal = this.countrySelected;

    auth.getUser().then((user) => {
      if (user !== null) {
        this.drawer = true;
        const idprofile = user.profile !== null ? Number(user.profile.sub) : 0;

        this.getUserProfileFunctionalities(idprofile).then((ret: any) => {
          const authUser: IAuthUser = {
            iduser: idprofile,
            username: user.profile !== null ? user.profile.email : '',
            fullusername: user.profile !== null ? user.profile.fullusername : '',
            isLogged: true,
            accessToken: user.access_token,
            functionalities: ret.data,
            isauthorized: ret.data.some(
              (f: any) => f.userinterfaceid === 'controlpanel-crud',
            ),
          };

          this.setLoggedUser(authUser);
        });
      } else {
        this.drawer = false;
      }
    });
  }

  public setDrawer() {
    if (this.authUser.isLogged === true) {
      this.drawer = !this.drawer;
    }
  }

  public logout() {
    auth.logout();
  }
}
